<template>
  <ExcludeFeatureWrapper :featureName="FEATURE_HANDLER.BOTTOM_NAVIGATE">
    <div class="navBarMobile text-uppercase">
      <!-- <div class="tooltipsWrapper">
      <div v-show="$store.getters.getterIsHomeScreen" class="tooltips">CSS Tooltip! Hover me!</div>
    </div> -->
      <div class="container">
        <div class="row">
          <!-- icon mua ve -->
          <div v-if="!isReview && !isThanhCo" class="col navBarMobileContent">
            <router-link class to="/" exact>
              <div class="w-100 navBarMobileLogo">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.8783 18.2L13 15.7083L9.12167 18.2L10.2917 13.7367L6.72751 10.8333L11.3317 10.5517L13 6.28334L14.6683 10.5517L19.2725 10.8333L15.7083 13.7367L16.8783 18.2ZM21.6667 13C21.6667 12.4254 21.8949 11.8743 22.3013 11.4679C22.7076 11.0616 23.2587 10.8333 23.8333 10.8333V6.50001C23.8333 5.92537 23.6051 5.37427 23.1987 4.96795C22.7924 4.56162 22.2413 4.33334 21.6667 4.33334H4.33334C3.7587 4.33334 3.2076 4.56162 2.80127 4.96795C2.39494 5.37427 2.16667 5.92537 2.16667 6.50001V10.8333C2.74131 10.8333 3.29241 11.0616 3.69874 11.4679C4.10507 11.8743 4.33334 12.4254 4.33334 13C4.33334 13.5746 4.10507 14.1257 3.69874 14.5321C3.29241 14.9384 2.74131 15.1667 2.16667 15.1667V19.5C2.16667 20.0746 2.39494 20.6257 2.80127 21.0321C3.2076 21.4384 3.7587 21.6667 4.33334 21.6667H21.6667C22.2413 21.6667 22.7924 21.4384 23.1987 21.0321C23.6051 20.6257 23.8333 20.0746 23.8333 19.5V15.1667C23.2587 15.1667 22.7076 14.9384 22.3013 14.5321C21.8949 14.1257 21.6667 13.5746 21.6667 13Z"
                    fill="#666"
                  />
                </svg>
              </div>
              <div>
                <p>mua vé</p>
              </div>
            </router-link>
          </div>
          <!-- <div v-if="!isReview && !getLoadByIframe" class="col navBarMobileContent">
          <router-link class to="/mua-sam">
            <div class="w-100 navBarMobileLogo">
              <img src="@/assets/img/tabbar-icon_vnshop.png" alt style="width: 85%; object-fit: contain;" />
            </div>
            <div>
              <p class="text-center">Mua sắm</p>
            </div>
          </router-link>
        </div> -->
          <!-- icon truc tuyen -->
          <!-- <div v-if="!isThanhCo" :class="isReview ? 'col-6' : 'col'" class="navBarMobileContent">
            <router-link class to="/ket-qua-truc-tuyen">
              <div class="w-100 navBarMobileLogo">
                <img src="@/assets/img/icon/icon-tabbar_keno-live.svg" alt style="width: 85%; object-fit: contain;" />
              </div>
              <div>
                <p class="text-center">KENO</p>
              </div>
            </router-link>
          </div> -->

          <div v-if="isThanhCo" class="navBarMobileContent col">
            <router-link class to="/thanhco-goi-y-so" exact>
              <div class="w-100 navBarMobileLogo">
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.8333 23.6667V21.3333H21.3333V17.8333H23.6667V21.9167C23.6667 22.3717 23.48 22.78 23.13 23.13C22.78 23.48 22.3717 23.6667 21.9167 23.6667H17.8333ZM6.16668 23.6667H2.08334C1.62834 23.6667 1.22001 23.48 0.87001 23.13C0.52001 22.78 0.333344 22.3717 0.333344 21.9167V17.8333H2.66668V21.3333H6.16668V23.6667ZM17.8333 0.333344H21.9167C22.3717 0.333344 22.78 0.52001 23.13 0.87001C23.48 1.22001 23.6667 1.62834 23.6667 2.08334V6.16668H21.3333V2.66668H17.8333V0.333344ZM6.16668 0.333344V2.66668H2.66668V6.16668H0.333344V2.08334C0.333344 1.62834 0.52001 1.22001 0.87001 0.87001C1.22001 0.52001 1.62834 0.333344 2.08334 0.333344H6.16668ZM10.25 5.00001C13.1667 5.00001 15.5 7.33334 15.5 10.25C15.5 11.2767 15.2083 12.2333 14.695 13.05L18.4983 16.8533L16.8533 18.4983L13.05 14.695C12.2333 15.2083 11.2767 15.5 10.25 15.5C7.33334 15.5 5.00001 13.1667 5.00001 10.25C5.00001 7.33334 7.33334 5.00001 10.25 5.00001ZM10.25 7.33334C9.47646 7.33334 8.7346 7.64063 8.18762 8.18762C7.64063 8.7346 7.33334 9.47646 7.33334 10.25C7.33334 11.0236 7.64063 11.7654 8.18762 12.3124C8.7346 12.8594 9.47646 13.1667 10.25 13.1667C11.0236 13.1667 11.7654 12.8594 12.3124 12.3124C12.8594 11.7654 13.1667 11.0236 13.1667 10.25C13.1667 9.47646 12.8594 8.7346 12.3124 8.18762C11.7654 7.64063 11.0236 7.33334 10.25 7.33334Z"
                  fill="#666666"
                />
              </svg> -->
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 2.1875C11.6637 2.1875 9.37989 2.88029 7.43733 4.17827C5.49478 5.47624 3.98074 7.3211 3.08668 9.47955C2.19262 11.638 1.95869 14.0131 2.41448 16.3045C2.87027 18.5959 3.9953 20.7007 5.64731 22.3527C7.29931 24.0047 9.4041 25.1297 11.6955 25.5855C13.9869 26.0413 16.362 25.8074 18.5205 24.9133C20.6789 24.0193 22.5238 22.5052 23.8217 20.5627C25.1197 18.6201 25.8125 16.3363 25.8125 14C25.8096 10.868 24.5642 7.86515 22.3495 5.6505C20.1349 3.43585 17.132 2.1904 14 2.1875ZM14 23.1875C12.1829 23.1875 10.4066 22.6487 8.8957 21.6391C7.38483 20.6296 6.20724 19.1947 5.51186 17.5159C4.81648 15.8371 4.63454 13.9898 4.98904 12.2076C5.34354 10.4254 6.21857 8.78835 7.50346 7.50346C8.78836 6.21856 10.4254 5.34354 12.2076 4.98904C13.9898 4.63453 15.8371 4.81648 17.5159 5.51186C19.1947 6.20724 20.6296 7.38482 21.6391 8.8957C22.6487 10.4066 23.1875 12.1829 23.1875 14C23.1846 16.4358 22.2157 18.771 20.4934 20.4933C18.771 22.2157 16.4358 23.1846 14 23.1875ZM16.9203 13.4531C17.4371 12.799 17.7184 11.9899 17.7188 11.1562C17.7222 10.4197 17.5062 9.69886 17.0984 9.08558C16.6905 8.47229 16.1092 7.99437 15.4287 7.71275C14.7481 7.43114 13.9991 7.35859 13.2771 7.50437C12.5552 7.65014 11.893 8.00763 11.375 8.53125C11.026 8.87308 10.7493 9.28163 10.5614 9.73259C10.3734 10.1836 10.2782 10.6677 10.2813 11.1562C10.2816 11.9899 10.5629 12.799 11.0797 13.4531H11.0578C10.4775 14.0348 10.0826 14.7753 9.92294 15.5813C9.76332 16.3873 9.84617 17.2225 10.161 17.9814C10.4759 18.7403 11.0086 19.3889 11.6919 19.8452C12.3752 20.3015 13.1784 20.545 14 20.545C14.8216 20.545 15.6248 20.3015 16.3081 19.8452C16.9914 19.3889 17.5241 18.7403 17.839 17.9814C18.1538 17.2225 18.2367 16.3873 18.0771 15.5813C17.9175 14.7753 17.5225 14.0348 16.9422 13.4531H16.9203ZM13.2234 11.9328C13.041 11.7534 12.9266 11.5162 12.8996 11.2617C12.8727 11.0072 12.9349 10.7513 13.0756 10.5376C13.2164 10.3239 13.427 10.1657 13.6714 10.0901C13.9159 10.0144 14.179 10.0259 14.4159 10.1226C14.6528 10.2194 14.8487 10.3954 14.9703 10.6206C15.0918 10.8457 15.1314 11.1061 15.0823 11.3573C15.0332 11.6084 14.8985 11.8347 14.7011 11.9975C14.5037 12.1603 14.2559 12.2496 14 12.25C13.856 12.2514 13.7131 12.2241 13.5798 12.1697C13.4464 12.1152 13.3253 12.0347 13.2234 11.9328ZM15.0828 17.4891C14.8323 17.7396 14.5027 17.8955 14.1502 17.9302C13.7976 17.965 13.4439 17.8764 13.1494 17.6796C12.8548 17.4828 12.6376 17.1899 12.5347 16.8509C12.4319 16.5119 12.4497 16.1478 12.5853 15.8205C12.7208 15.4932 12.9657 15.223 13.2781 15.056C13.5905 14.8889 13.9512 14.8354 14.2986 14.9045C14.6461 14.9736 14.9588 15.161 15.1836 15.4349C15.4084 15.7087 15.5312 16.052 15.5313 16.4062C15.5301 16.8121 15.369 17.2012 15.0828 17.4891Z"
                    fill="#D31904"
                  />
                </svg>
              </div>
              <div>
                <p>Gợi ý số</p>
              </div>
            </router-link>
          </div>

          <!-- icon do ve -->
          <div v-if="isThanhCo" class="navBarMobileContent col">
            <router-link class to="/thanhco-do-ve" exact>
              <div class="w-100 navBarMobileLogo">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.8333 23.6667V21.3333H21.3333V17.8333H23.6667V21.9167C23.6667 22.3717 23.48 22.78 23.13 23.13C22.78 23.48 22.3717 23.6667 21.9167 23.6667H17.8333ZM6.16668 23.6667H2.08334C1.62834 23.6667 1.22001 23.48 0.87001 23.13C0.52001 22.78 0.333344 22.3717 0.333344 21.9167V17.8333H2.66668V21.3333H6.16668V23.6667ZM17.8333 0.333344H21.9167C22.3717 0.333344 22.78 0.52001 23.13 0.87001C23.48 1.22001 23.6667 1.62834 23.6667 2.08334V6.16668H21.3333V2.66668H17.8333V0.333344ZM6.16668 0.333344V2.66668H2.66668V6.16668H0.333344V2.08334C0.333344 1.62834 0.52001 1.22001 0.87001 0.87001C1.22001 0.52001 1.62834 0.333344 2.08334 0.333344H6.16668ZM10.25 5.00001C13.1667 5.00001 15.5 7.33334 15.5 10.25C15.5 11.2767 15.2083 12.2333 14.695 13.05L18.4983 16.8533L16.8533 18.4983L13.05 14.695C12.2333 15.2083 11.2767 15.5 10.25 15.5C7.33334 15.5 5.00001 13.1667 5.00001 10.25C5.00001 7.33334 7.33334 5.00001 10.25 5.00001ZM10.25 7.33334C9.47646 7.33334 8.7346 7.64063 8.18762 8.18762C7.64063 8.7346 7.33334 9.47646 7.33334 10.25C7.33334 11.0236 7.64063 11.7654 8.18762 12.3124C8.7346 12.8594 9.47646 13.1667 10.25 13.1667C11.0236 13.1667 11.7654 12.8594 12.3124 12.3124C12.8594 11.7654 13.1667 11.0236 13.1667 10.25C13.1667 9.47646 12.8594 8.7346 12.3124 8.18762C11.7654 7.64063 11.0236 7.33334 10.25 7.33334Z"
                    fill="#666666"
                  />
                </svg>
              </div>
              <div>
                <p>Dò vé số</p>
              </div>
            </router-link>
          </div>

          <!-- icon ket qua -->
          <ExcludeFeatureWrapper :featureName="FEATURE_HANDLER.TAB_LOTTERY_RESULT" class="navBarMobileContent col">
            <router-link
              :class="{ 'router-link-exact-active': isActiveResultTab, 'router-link-active': isActiveResultTab }"
              :to="getterResultGameUrlXSMN.url"
            >
              <div class="w-100 navBarMobileLogo">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.66667 2.16666H17.3333C19.0572 2.16666 20.7105 2.85148 21.9295 4.07046C23.1485 5.28945 23.8333 6.94275 23.8333 8.66666V17.3333C23.8333 19.0572 23.1485 20.7105 21.9295 21.9295C20.7105 23.1485 19.0572 23.8333 17.3333 23.8333H8.66667C6.94276 23.8333 5.28946 23.1485 4.07047 21.9295C2.85149 20.7105 2.16667 19.0572 2.16667 17.3333L2.16667 8.66666C2.16667 6.94275 2.85149 5.28945 4.07047 4.07046C5.28946 2.85148 6.94276 2.16666 8.66667 2.16666V2.16666ZM15.1667 11.9167C14.8793 11.9167 14.6038 12.0308 14.4006 12.234C14.1975 12.4371 14.0833 12.7127 14.0833 13C14.0833 13.2873 14.1975 13.5629 14.4006 13.766C14.6038 13.9692 14.8793 14.0833 15.1667 14.0833H18.4167C18.704 14.0833 18.9795 13.9692 19.1827 13.766C19.3859 13.5629 19.5 13.2873 19.5 13C19.5 12.7127 19.3859 12.4371 19.1827 12.234C18.9795 12.0308 18.704 11.9167 18.4167 11.9167H15.1667ZM13 16.25C12.7127 16.25 12.4371 16.3641 12.234 16.5673C12.0308 16.7705 11.9167 17.046 11.9167 17.3333C11.9167 17.6206 12.0308 17.8962 12.234 18.0994C12.4371 18.3025 12.7127 18.4167 13 18.4167H18.4167C18.704 18.4167 18.9795 18.3025 19.1827 18.0994C19.3859 17.8962 19.5 17.6206 19.5 17.3333C19.5 17.046 19.3859 16.7705 19.1827 16.5673C18.9795 16.3641 18.704 16.25 18.4167 16.25H13ZM13 7.58332C12.7127 7.58332 12.4371 7.69746 12.234 7.90062C12.0308 8.10379 11.9167 8.37934 11.9167 8.66666C11.9167 8.95397 12.0308 9.22952 12.234 9.43269C12.4371 9.63585 12.7127 9.74999 13 9.74999H18.4167C18.704 9.74999 18.9795 9.63585 19.1827 9.43269C19.3859 9.22952 19.5 8.95397 19.5 8.66666C19.5 8.37934 19.3859 8.10379 19.1827 7.90062C18.9795 7.69746 18.704 7.58332 18.4167 7.58332H13ZM8.48033 13.2632L7.71442 12.4973C7.61448 12.3939 7.49494 12.3113 7.36277 12.2545C7.2306 12.1978 7.08845 12.1679 6.9446 12.1666C6.80076 12.1654 6.6581 12.1928 6.52497 12.2473C6.39183 12.3017 6.27087 12.3822 6.16916 12.4839C6.06744 12.5856 5.987 12.7066 5.93253 12.8397C5.87806 12.9728 5.85064 13.1155 5.85189 13.2593C5.85314 13.4032 5.88303 13.5453 5.93981 13.6775C5.99658 13.8097 6.07911 13.9292 6.18258 14.0292L7.71442 15.561C7.81503 15.6617 7.93451 15.7416 8.06602 15.7961C8.19754 15.8507 8.33851 15.8787 8.48087 15.8787C8.62324 15.8787 8.76421 15.8507 8.89573 15.7961C9.02724 15.7416 9.14672 15.6617 9.24733 15.561L12.311 12.4973C12.5144 12.2942 12.6288 12.0186 12.629 11.7311C12.6292 11.4436 12.5152 11.1678 12.3121 10.9644C12.1089 10.761 11.8333 10.6466 11.5458 10.6464C11.2584 10.6462 10.9826 10.7602 10.7792 10.9633L8.48033 13.2622V13.2632Z"
                    fill="#666666"
                  />
                </svg>
              </div>
              <div>
                <p>kết quả</p>
              </div>
            </router-link>
          </ExcludeFeatureWrapper>

          <!-- Vé đã mua -->
          <div v-if="!isReview && !isThanhCo && loggedIn" class="col navBarMobileContent">
            <router-link class to="/tai-khoan/lich-su-dat-mua/" exact>
              <div class="w-100 navBarMobileLogo">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.0833 9.20834H11.9167V7.04168H14.0833V9.20834ZM14.0833 14.0833H11.9167V11.9167H14.0833V14.0833ZM14.0833 18.9583H11.9167V16.7917H14.0833V18.9583ZM23.8333 10.8333V6.50001C23.8333 5.92537 23.6051 5.37427 23.1987 4.96795C22.7924 4.56162 22.2413 4.33334 21.6667 4.33334H4.33333C3.7587 4.33334 3.2076 4.56162 2.80127 4.96795C2.39494 5.37427 2.16667 5.92537 2.16667 6.50001V10.8333C2.7413 10.8333 3.2924 11.0616 3.69873 11.4679C4.10506 11.8743 4.33333 12.4254 4.33333 13C4.33333 13.5746 4.10506 14.1257 3.69873 14.5321C3.2924 14.9384 2.7413 15.1667 2.16667 15.1667V19.5C2.16667 20.0746 2.39494 20.6257 2.80127 21.0321C3.2076 21.4384 3.7587 21.6667 4.33333 21.6667H21.6667C22.2413 21.6667 22.7924 21.4384 23.1987 21.0321C23.6051 20.6257 23.8333 20.0746 23.8333 19.5V15.1667C23.2587 15.1667 22.7076 14.9384 22.3013 14.5321C21.8949 14.1257 21.6667 13.5746 21.6667 13C21.6667 12.4254 21.8949 11.8743 22.3013 11.4679C22.7076 11.0616 23.2587 10.8333 23.8333 10.8333Z"
                    fill="#666666"
                  />
                </svg>
              </div>
              <div>
                <p>vé đã mua</p>
              </div>
            </router-link>
          </div>

          <!-- icon tai khoan -->
          <div v-if="!isReview && !isThanhCo" class="col p-0">
            <div v-if="loggedIn" class="w-100 navBarMobileContent">
              <router-link class to="/tai-khoan">
                <div class="w-100 navBarMobileLogo">
                  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13 4.33334C14.1493 4.33334 15.2515 4.78989 16.0641 5.60255C16.8768 6.4152 17.3333 7.51741 17.3333 8.66668C17.3333 9.81595 16.8768 10.9181 16.0641 11.7308C15.2515 12.5435 14.1493 13 13 13C11.8507 13 10.7485 12.5435 9.93586 11.7308C9.12321 10.9181 8.66666 9.81595 8.66666 8.66668C8.66666 7.51741 9.12321 6.4152 9.93586 5.60255C10.7485 4.78989 11.8507 4.33334 13 4.33334V4.33334ZM13 15.1667C17.7883 15.1667 21.6667 17.1058 21.6667 19.5V21.6667H4.33333V19.5C4.33333 17.1058 8.21166 15.1667 13 15.1667Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
                <div>
                  <p>tài khoản</p>
                </div>
              </router-link>
            </div>
            <div v-else class="w-100 navBarMobileContent" @click="hanlerLogin">
              <div class="navBarMobileContentModalLogin">
                <div class="w-100 navBarMobileLogo">
                  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13 4.33334C14.1493 4.33334 15.2515 4.78989 16.0641 5.60255C16.8768 6.4152 17.3333 7.51741 17.3333 8.66668C17.3333 9.81595 16.8768 10.9181 16.0641 11.7308C15.2515 12.5435 14.1493 13 13 13C11.8507 13 10.7485 12.5435 9.93586 11.7308C9.12321 10.9181 8.66666 9.81595 8.66666 8.66668C8.66666 7.51741 9.12321 6.4152 9.93586 5.60255C10.7485 4.78989 11.8507 4.33334 13 4.33334V4.33334ZM13 15.1667C17.7883 15.1667 21.6667 17.1058 21.6667 19.5V21.6667H4.33333V19.5C4.33333 17.1058 8.21166 15.1667 13 15.1667Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
                <div>
                  <p>tài khoản</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ExcludeFeatureWrapper>
</template>
<script>
import ExcludeFeatureWrapper from './ExcludeFeatureWrapper.vue';
export default {
  data() {
    return {
      isActiveResultTab: false
    };
  },
  components: { ExcludeFeatureWrapper },
  beforeCreate() {},
  created() {
    const urls = this.getterResultGameUrl.map((item) => item.url);
    this.isActiveResultTab = urls.includes(this.$route.path);
  },
  mounted() {},
  computed: {
    isApp() {
      return this.$store.getters.getterIsApp;
    },
    getLoadByIframe() {
      return this.$store.state.loadByIframe;
    },
    getterResultGameUrl() {
      return this.$store.getters.getterResultGameUrl;
    },
    getterResultGameUrlXSMN() {
      return this.$store.getters.getterResultGameUrl.find((item) => item.slug === 'xsmn');
    },
    loggedIn() {
      return this.$store.getters.getterLoggedIn;
    }
  },
  methods: {
    hanlerLogin() {
      this.$store.commit('setRedirectAfterLogin', null);
      this.$store.commit('setModalLogin', true);
    }
  }
};
</script>
<style lang="scss" scoped>
.tooltipsWrapper {
  transition: 0.3s all;
}
.tooltips {
  border-width: 12px 6px 0 6px;
  background-color: #444;
  content: '';
  left: 50%;
  bottom: 70px;
  position: absolute;
  width: 220px;
  transform: translate(-50%, 0);
  color: #fff;
}
// .tooltips:after {
//   display: -webkit-flex;
//   display: flex;
//   -webkit-justify-content: center;
//   justify-content: center;
//   background: #444;
//   border-radius: 8px;
//   color: #fff;
//   content: attr(title);
//   margin: -82px auto 0;
//   font-size: 16px;
//   padding: 13px;
//   width: 220px;
// }
// .tooltips:before {
//   border: solid;
//   border-color: #444 transparent;
//   border-width: 12px 6px 0 6px;
//   content: '';
//   left: 45%;
//   bottom: 30px;
//   position: absolute;
// }
</style>
